import { types } from './types';

export const setGetPostbackLogsAction = (payload) => {
  return {
    type: types.SET_GET_POSTBACK_LOGS,
    payload,
  }
}